export default __webpack_public_path__ + "static/media/vergne15-16.f9fff7ff.png";